/**
 * @generated SignedSource<<267046878b6f8400fd3a4d7de5de6140>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentCoverImageContent$data = {
  readonly images: ReadonlyArray<{
    readonly size1200x1200: {
      readonly url: string | null;
    } | null;
    readonly size1200x800: {
      readonly url: string | null;
    } | null;
    readonly size1280x720: {
      readonly url: string | null;
    } | null;
    readonly size320x240: {
      readonly url: string | null;
    } | null;
    readonly size500x500: {
      readonly url: string | null;
    } | null;
    readonly size540x360: {
      readonly url: string | null;
    } | null;
    readonly size768x768: {
      readonly url: string | null;
    } | null;
    readonly size800x1200: {
      readonly url: string | null;
    } | null;
    readonly size80x80: {
      readonly url: string | null;
    } | null;
    readonly title: string | null;
    readonly type: string | null;
    readonly url: string;
  } | null> | null;
  readonly " $fragmentType": "contentCoverImageContent";
};
export type contentCoverImageContent$key = {
  readonly " $data"?: contentCoverImageContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentCoverImageContent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentCoverImageContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": "size1200x800",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "1200x800"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "style(filter:{\"style\":\"1200x800\"})"
        },
        {
          "alias": "size1200x1200",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "1200x1200"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "style(filter:{\"style\":\"1200x1200\"})"
        },
        {
          "alias": "size1280x720",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "wide_landscape"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
        },
        {
          "alias": "size768x768",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "768x768"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "style(filter:{\"style\":\"768x768\"})"
        },
        {
          "alias": "size540x360",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "540x360"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "style(filter:{\"style\":\"540x360\"})"
        },
        {
          "alias": "size320x240",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "320x240"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "style(filter:{\"style\":\"320x240\"})"
        },
        {
          "alias": "size80x80",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "80x80"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "style(filter:{\"style\":\"80x80\"})"
        },
        {
          "alias": "size500x500",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "500x500"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "style(filter:{\"style\":\"500x500\"})"
        },
        {
          "alias": "size800x1200",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "portrait"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "style(filter:{\"style\":\"portrait\"})"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};
})();

(node as any).hash = "6a0681d621316f42ef6adc6c54e1094d";

export default node;
